import { createAgent, listDataAgent, updateAgent } from '@/zsm-api-new/agent.js'

const state = {

}
const mutations = {

}

const actions = {
  // 创建介绍人
  createAgent({ commit }, info) {
	  return new Promise((resolve, reject) => {
	    createAgent(info).then(response => {
	      resolve(response)
	    }).catch(error => {
	      reject(error)
	    })
	  })
  },
  // 介绍人列表
  listDataAgent({ commit }, info) {
	  return new Promise((resolve, reject) => {
	    listDataAgent(info).then(response => {
	      resolve(response)
	    }).catch(error => {
	      reject(error)
	    })
	  })
  },

  // 修改介绍人
  updateAgent({ commit }, info) {
    return new Promise((resolve, reject) => {
      updateAgent(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
